import React from 'react'

import TableRowActions from '@/app/component/layout/table/actions'
import { Export } from '@/app/module/exports/types'

type Props = {
  item: Export

  onDelete: (exportId: number) => Promise<boolean>
  onView?: (exportId: number) => void
}

const ExportActionMenu: React.FC<Props> = ({ item, onDelete, onView }) => {
  const config = React.useMemo(() => {
    const actions = []

    if (onView) {
      actions.push({
        icon: 'visibility',
        label: 'View Report',
        onClick: () => onView(item.id),
        tooltip: 'View report in reports',
      })
    }

    actions.push({
      icon: 'delete',
      label: 'Delete',
      onClick: () => onDelete(item.id),
      tooltip: 'Delete this export',
    })

    return actions
  }, [item.id, onDelete, onView])

  return <TableRowActions config={config} />
}

export default ExportActionMenu
